var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bg-FF p-20" },
    _vm._l(_vm.taskTracks, function (item, index) {
      return _c(
        "div",
        { key: index, staticClass: "p-10" },
        [
          _c("div", { staticClass: "flex col-center" }, [
            _c("img", {
              staticClass: "w-46 h-46",
              attrs: {
                src: _vm.getOpinionIcon(
                  item.optionVOList,
                  _vm.getTrackTimeStamp(item, index, _vm.data),
                  index,
                  _vm.data,
                  item
                ),
              },
            }),
            _c(
              "div",
              { staticClass: "flex-1 font-30 cor-33 font-weight-600 m-l-24" },
              [_vm._v(_vm._s(item.name))]
            ),
            _c("div", { staticClass: "font-28 cor-99 white-spc-nowrap" }, [
              _vm._v(
                " " +
                  _vm._s(
                    item.endTime == null
                      ? ""
                      : _vm.moment(item.endTime).format("YYYY-MM-DD")
                  ) +
                  " "
              ),
            ]),
          ]),
          item.assigneeName
            ? _c(
                "div",
                {
                  staticClass: "flex p-t-20 p-l-70 p-r-30 rela",
                  class:
                    index + 1 != _vm.taskTracks.length ? "border-left" : "",
                },
                [
                  _c("img", {
                    staticClass: "w-24 h-28",
                    attrs: { src: `${_vm.image_base_url}/ren.png` },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "font-28 cor-F8BD29 font-weight-500 m-l-10",
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            item.assigneeName == null ? "" : item.assigneeName
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._l(item.assigneeNames, function (csuser, index) {
            return (item.assigneeNames && item.assigneeNames.length > 0) ||
              item.isCs
              ? _c(
                  "div",
                  {
                    staticClass: "flex p-t-20 p-l-70 p-r-30 rela",
                    class: index + 1 != _vm.data.length ? "border-left" : "",
                  },
                  [
                    _c("img", {
                      staticClass: "w-24 h-28",
                      attrs: { src: `${_vm.image_base_url}/ren.png` },
                    }),
                    _c(
                      "div",
                      {
                        staticClass:
                          "font-28 cor-F8BD29 font-weight-500 m-l-10",
                      },
                      [_vm._v(_vm._s(csuser.userName))]
                    ),
                    _c("span", { staticClass: "font-28" }, [_vm._v("（")]),
                    csuser.readFlag
                      ? _c(
                          "div",
                          {
                            staticClass: "font-28",
                            style: {
                              color: csuser.readTime ? "#47bc82" : "#f25643",
                            },
                          },
                          [_vm._v(" " + _vm._s(csuser.readFlag) + " ")]
                        )
                      : _vm._e(),
                    _c("span", { staticClass: "font-28" }, [_vm._v(" ）")]),
                  ]
                )
              : _vm._e()
          }),
          _vm._l(item.optionVOList, function (option, index) {
            return item.optionVOList && item.optionVOList.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "flex p-l-70 p-b-20 p-r-30 rela",
                    class: index + 1 != _vm.data.length ? "border-left" : "",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "p-t-10 font-32 font-weight-500 m-l-10" },
                      [
                        option.userName
                          ? _c("div", [
                              _c("i", {
                                staticClass: "el-icon-user-solid font-16",
                                staticStyle: { color: "#FFB751" },
                              }),
                              _c("span", { staticClass: "cor-F8BD29" }, [
                                _vm._v(" " + _vm._s(option.userName) + " "),
                              ]),
                            ])
                          : _vm._e(),
                        option.createTime
                          ? _c(
                              "div",
                              { staticClass: "opinionContent font-32" },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.getOpinion(option)) + " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                )
              : _vm._e()
          }),
          item.attachmentVOList
            ? _c(
                "div",
                { staticClass: "flex p-l-70 p-b-20 p-r-30 rela" },
                _vm._l(item.attachmentVOList, function (img, i) {
                  return _c("img", {
                    key: i,
                    staticClass: "w-150 h-150",
                    class: { "m-l-16": i !== 0 },
                    attrs: { src: img.url },
                    on: {
                      click: function ($event) {
                        return _vm.previewImg(item.attachmentVOList, i)
                      },
                    },
                  })
                }),
                0
              )
            : _vm._e(),
          item.signImage
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    color: "rgb(168, 173, 175)",
                    "padding-top": "5px",
                    "vertical-align": "top",
                  },
                },
                [
                  _c("div", [_vm._v("签名：")]),
                  _c("img", {
                    attrs: {
                      src: item.signImage,
                      width: "160px",
                      height: "90px",
                    },
                  }),
                ]
              )
            : _vm._e(),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }